import { render, staticRenderFns } from "./AddTrainReocrd.vue?vue&type=template&id=66dfcc96&scoped=true"
import script from "./AddTrainReocrd.vue?vue&type=script&lang=js"
export * from "./AddTrainReocrd.vue?vue&type=script&lang=js"
import style0 from "./AddTrainReocrd.vue?vue&type=style&index=0&id=66dfcc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfcc96",
  null
  
)

export default component.exports